import { Middleware } from "polymatic";

export const on = (eventName: string) => {
  return (value: any, context: ClassMethodDecoratorContext | ClassFieldDecoratorContext) => {
    const isCallable = context.kind === "method" || context.kind === "field";
    if (!isCallable || context.static) {
      throw new Error("@on can only be used on instance methods or function fields");
    }

    const fieldName = String(context.name);

    context.addInitializer(function (this: any) {
      if (!isMiddlewareInstance(this as any)) {
        console.warn(`@on can only be used in a Middleware`);
        return;
      }

      const fn = this[context.name as string | symbol];
      if (typeof fn !== "function") {
        throw new Error(
          `@on("${eventName}") can only be used on methods or function fields. ` +
            `Got ${typeof fn} for property "${String(context.name)}"`,
        );
      }

      this.on(eventName, fn.bind(this));
    });
  };
};

function isMiddlewareInstance(obj: object): obj is Middleware {
  return obj instanceof Middleware || Object.getPrototypeOf(obj)?.constructor === Middleware;
}

export function use() {
  return function (value: undefined, context: ClassFieldDecoratorContext) {
    if (context.kind !== "field" || context.static) {
      throw new Error("@use can only be used on instance fields");
    }

    return function <T extends Middleware>(this: Middleware, child: T) {
      if (!isMiddlewareInstance(this as any)) {
        console.warn(`@use can only be used in a Middleware`);
        return;
      }

      if (!isMiddlewareInstance(child)) {
        throw new Error(
          `@use field "${String(context.name)}" in ${this.constructor.name} ` +
            `does not contain a Middleware instance`,
        );
      }

      this.use(child);

      return child;
    };
  };
}
